import { render, staticRenderFns } from "./ItensLotesVisualizacao.vue?vue&type=template&id=48a1208f&scoped=true"
import script from "./ItensLotesVisualizacao.vue?vue&type=script&lang=js"
export * from "./ItensLotesVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./ItensLotesVisualizacao.vue?vue&type=style&index=0&id=48a1208f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a1208f",
  null
  
)

export default component.exports